// Google Sheets Integration
// Configuração para enviar dados do formulário para Google Sheets

export interface LeadData {
  timestamp: string;
  fullName: string;
  whatsapp: string;
  instagram: string;
  revenueRange: string;
  revenueLabel: string;
  source: string;
}

// URL do Google Apps Script Web App
const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbw2IyLeVs-jw0EXIm1OXM1fcxlvIlslppxBPUC7fsiM0uJSgBf-Aut4pA8C3MHme-L2Rg/exec';

export async function sendToGoogleSheets(data: LeadData): Promise<boolean> {
  try {
    const response = await fetch(GOOGLE_SCRIPT_URL, {
      method: 'POST',
      mode: 'no-cors', // Necessário para Google Apps Script
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    // Com mode: 'no-cors', não podemos ler a resposta
    // Assumimos sucesso se não houver erro
    return true;
  } catch (error) {
    console.error('Erro ao enviar para Google Sheets:', error);
    return false;
  }
}

export function getRevenueLabel(value: string): string {
  const labels: Record<string, string> = {
    'none': 'Não informado',
    '0-50k': 'Até R$ 50.000/mês',
    '50k-100k': 'R$ 50.000 - R$ 100.000/mês',
    '100k-250k': 'R$ 100.000 - R$ 250.000/mês',
    '250k-500k': 'R$ 250.000 - R$ 500.000/mês',
    '500k+': 'Acima de R$ 500.000/mês',
  };
  return labels[value] || value;
}

export function getCurrentTimestamp(): string {
  const now = new Date();
  return now.toLocaleString('pt-BR', {
    timeZone: 'America/Sao_Paulo',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
}
